var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isGridShow)?_c('MyGridLayout',{attrs:{"layout-data":_vm.layoutData}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }